export const THEME_REALDANIA = 'REALDANIA';
export const THEME_JUBILAEUM = 'JUBILAEUM';
export const THEME_UNDERVAERKER = 'UNDERVAERKER';

export const THEME_REALDANIA_WALLPAPER = '/images/jarmers-plads-forplads-skatere.jpg';
export const THEME_JUBILAEUM_WALLPAPER = '/images/jubilaeum.jpg';
export const THEME_UNDERVAERKER_WALLPAPER = '/images/undervaerker.jpg';

export const THEME_REALDANIA_LOGO = '/images/logo-filled.svg';
export const THEME_JUBILAEUM_LOGO = '/images/vores-sted-logo.png';
